// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import Localize from '@ta/platform.i18n';
import styles from './ReportVoteThankYou.css';

const ReportVoteThankYou = () => (
  <div className={styles.iapTYContent}>
    <p className={styles.iapTYH1} style={{ textAlign: 'center' }}>
      <Localize id="social_report_ty2" /> {/* Thank you! */}
    </p>
    <p className={styles.iapTYText}>
      <Localize id="social_report_ty2b" />{' '}
      {/* Your report has been submitted and someone from our team will look at it soon! */}
    </p>
  </div>
);

export default ReportVoteThankYou;
